import React, { Component } from "react";
import { fetchDropdownList, fetchPermissions } from "../../redux";
import { connect } from "react-redux";
import { socketInitialize } from "../../services/SocketServices";

export class LoadDropdwon extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  componentDidMount = async() => {
    // Geeting dropdown list data
    
  // console.log("permission",this.props.permissionData.permissionsData)
    const isDropdownEmpty = !Object.keys(
      this.props.dropdownListData.dropdownList
    ).length;
    
    if (isDropdownEmpty) {
      this.props.fetchDropdownList();
    }

    //getting permission data
    // const isPermissionDataEmpty = !Object.keys(
    //   this.props.permissionData.permissionsData.permissionList
    // ).length;
// console.log("JSON.parse(localStorage.getItem", JSON.parse(localStorage.getItem("USER_INFO")))
    if (JSON.parse(localStorage.getItem("USER_INFO")) &&  JSON.parse(localStorage.getItem("USER_INFO")).token ) {
      let role_id = JSON.parse(localStorage.getItem("USER_INFO")).systemRole;
     await this.props.fetchPermissions(role_id);
     // socketInitialize();
    }
  }

  static getDerived;

  render() {
    return <div></div>;
  }
}

// export default LoadDropdwon;
const mapStateToProps = (state) => {
  return {
    dropdownListData: state.dropdownList,
    permissionData: state.permissionData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDropdownList: () => dispatch(fetchDropdownList()),
    fetchPermissions: (role_id) => dispatch(fetchPermissions(role_id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoadDropdwon);
